export type AccessRole = "customer" | "partner";

export const ACCESS_ROLE_OPTIONS: {
  value: AccessRole;
  label: string;
  description: string;
}[] = [
  {
    value: "customer",
    label: "Customer",
    description: "Signing up for your own studio or business.",
  },
  {
    value: "partner",
    label: "Partner",
    description: "Building on behalf of one or more Glofox customers.",
  },
];

export function formatAccessRoleLabel(value: AccessRole | null | undefined): string {
  if (!value) {
    return "Not set";
  }

  return (
    ACCESS_ROLE_OPTIONS.find((option) => option.value === value)?.label ?? value
  );
}
